module.exports = __webpack_public_path__ + "img/Ranking.b42dd4e3.png";